import { Component, OnInit, ViewChild, HostListener, TemplateRef, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, NavigationError, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { LayoutUtilsService, LoaderService, RequestService } from '../../../shared/services';
import * as moment from 'moment';
// import { CustomSelectAutocompleteComponent } from '../../../shared/components/custom-select-autocomplete/custom-select-autocomplete.component';
// import { ModalUserViewDialogComponent } from '../custom-user-view-dialog/custom-user-view-dialog.component';
import { MatDialog } from '@angular/material/dialog';
// import * as moment from 'moment';
// import { ModalLanguageDialogComponent } from '../custom-language-dialog/custom-language-dialog.component';
import { NotificationService } from '../../services/notification.service';
import { ModalDialogComponent } from '../custom-dialog/custom-dialog.component';
import { ModalPasswordDialogComponent } from '../custom-password-dialog/custom-password-dialog.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { ModalCropDialogComponent } from '../custom-crop-dialog/custom-crop-dialog.component';
import { ModalLanguageDialogComponent } from '../custom-language-dialog/custom-language-dialog.component';
import { ChatService } from '../../services/chat.service';
import { UnReadChatDialogComponent } from './unread-chat-dialog/unread-chat-dialog.component';
import { SupportDialogComponent } from './support-dialog/support-dialog.component';
import { UnReadNotificationsDialogComponent } from './unread-notifications-dialog/unread-notifications-dialog.component';
import { LogsInvestigatorMapDialogComponent } from 'src/app/pages/case-page/investigator/logs-investigator-dialog/logs-investigator-dialog.component';
import { NotificationsHandlersService } from '../../services/notifications-handlers.service';
import { getResponsiveDialogWidth } from '../../helpers';
import { getOrganizationTemplateDisplayName, resolveTemplateImageSrc } from '../../constants/template-options';
import { shouldBypassDnd } from '../../utils/dnd-bypass';
import { CaseService } from '../../services/case.service';
import { ViewTimelineDialogComponent } from 'src/app/pages/case-page/timeline/view-timeline-dialog/view-timeline-dialog.component';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss']
})
export class TopnavComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private readonly CODE_VERSION_STORAGE_KEY = 'civix-code-version';
  private hasPromptedCodeVersionUpdate = false;
  private lastPromptedCodeVersion: string | null = null;
  public selectedUser: any;
  public languageSelected: string = 'en';
  public title = getOrganizationTemplateDisplayName();
  public subTitle = environment.subServerName;
  public pushRightClass: string = 'push-right';
  // public selectedOrganization: string = '';
  // public userType: string = 'default';
  // public dataType: string = 'organization';
  // public dataTypeDisplay: string = 'Organization';
  // public selectedDatafilters: any = undefined;
  // public prefectureTitle: string = '';
  // public prefectureEnums: any[] = [];
  public prefecture: string = '';
  public hasNew: boolean = false;
  public isThreatMuted: boolean = false;
  // public pageSize = 10;
  // public showNotificationUnRead: boolean = false;
  public joinCallInvite: any = {};
  public currentNotification: any = undefined;
  public notificationTimer: any = undefined;
  public notificationAudio: any = undefined;
  // public newCase: any = undefined;
  // public notificationTimeout: any = undefined;
  public isSuperAdmin: boolean = false;
  public loading: boolean = false;
  // public metaFieldTabsSetting = [];
  // public showChangePassword: boolean = false;
  // public DND: boolean = false;
  public date: Date;
  // public screenWidth: number;
  public pictureLink: string = 'assets/images/profile.png';
  public isDnd: boolean = true;
  public languageSelection: boolean = environment.languageSelection;
  public role: string = '';
  // public hasNewChatMessages: boolean = false;
  public currentRoute: string = '';
  public unread: any = [];
  public unreadNotifications: any = [];
  public notificationsList: any[] = [];
  public notificationsLoaded: boolean = false;
  public notificationsLoading: boolean = false;
  private notificationsRefreshPending: boolean = false;
  public unreadNumber: number = 0;
  public unreadNotificationsNumber: number = 0;
  public statusEnum: any = [];
  public threatTypeEnum: any = [];
  public topLogoSrc: string = undefined;
  public loginLogoSrc: string = undefined;
  public langs: string[] = ['en', 'ja'];
  public isLoadedOnce = false;
  public enableSurveillance: boolean = false;
  public isFullscreen: boolean = false;
  public isCaseDashboardPage: boolean = false;
  // public tableDataTemp: any = undefined;
  // public fieldsDetails: any = undefined;

  // @ViewChild('customselectautocomplete') customselectautocomplete: CustomSelectAutocompleteComponent;
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;
  @ViewChild('notificationsMenuTrigger') notificationsMenuTrigger!: MatMenuTrigger;
  // @ViewChild('notification') set playerRef(ref: ElementRef<HTMLAudioElement>) {
  //   if (ref)
  //     this.notificationAudio = ref.nativeElement;
  // }
  @Input() headerTemplate: TemplateRef<any>;

  constructor(private requestService: RequestService, public router: Router, private translate: TranslateService, private loaderService: LoaderService, private chatService: ChatService,
    public dialog: MatDialog, private layoutUtilsService: LayoutUtilsService, private notificationService: NotificationService, private notificationsHandlersService: NotificationsHandlersService, private cdr: ChangeDetectorRef, private caseService: CaseService) {
    if (localStorage.getItem('languageSelected')) {
      this.languageSelected = localStorage.getItem('languageSelected');
    }
    // this.userType = this.requestService.getUserType();
    // this.prefecture = this.translate.instant(environment.prefecture + ' Prefectural Police Headquarters');
    this.prefecture = this.translate.instant('Prefectural Police Headquarters');
    this.refreshCaseDashboardRoute(this.router.url);

    router.events.subscribe((data) => {
      if (data instanceof NavigationEnd ||
        data instanceof NavigationError) {
        this.currentRoute = data instanceof NavigationEnd ? data.urlAfterRedirects : data.url;
        this.refreshCaseDashboardRoute(this.currentRoute);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(el => el.unsubscribe());
  }

  ngOnInit() {
    this.isFullscreen = !!document.fullscreenElement;
    moment.locale(this.requestService.lang);
    this.caseService.getCaseMetadata();
    this.caseService.getNoteMetadata();
    this.caseService.getThreatMetadata();

    this.subscriptions.push(this.caseService.caseMetadata.subscribe((metadata: any) => {
      if (metadata) {
        this.statusEnum = metadata.fields.find(i => i.name == 'status')?.enum;
      }
    }));

    this.subscriptions.push(this.caseService.threatMetadata.subscribe((metadata: any) => {
      if (metadata) {
        this.threatTypeEnum = metadata.fields.find(i => i.name == 'threat_type')?.enum;
      }
    }));

    void resolveTemplateImageSrc('logo-text-login-black.png', 'assets/images/logo-text-login-black.png', this.requestService.pageOrganization.getValue())
      .then((src) => {
        this.loginLogoSrc = src;
      });
    // Listen to call events to clear active invites
    const callChannel = new BroadcastChannel('call_notifications');
    callChannel.addEventListener('message', (event) => {
      if (event.data?.type === 'call-status') {
        const message = event.data.payload;
        if (message?.status === 'ended' || message?.status === 'declined' || message?.status === 'not-answered') {
          this.notificationsHandlersService.closeCallInviteNotifications(message?.callSessionId);
          this.joinCallInvite = {};
          this.currentNotification = null;
        }
      }
      else if (event.data?.type === 'call-invite-accepted') {
        this.notificationsHandlersService.closeCallInviteNotifications(event.data?.payload?.callSessionId);
        this.joinCallInvite = {};
        this.currentNotification = null;
      }
    });

    this.subscriptions.push(
      this.requestService.pageOrganization.subscribe((data) => {
        if (data) {
          let organization = data;
          let settings = this.requestService.getSettings(organization);
          this.langs = settings.langs;

          this.enableSurveillance = settings.enableSurveillance || false;
        }
      })
    );
    // this.screenWidth = window.innerWidth;
    this.date = new Date();
    // Compute logo from centralized brand service
    void resolveTemplateImageSrc('logo-text.png', 'assets/images/logo-text.png', this.requestService.pageOrganization.getValue())
      .then((src) => {
        this.topLogoSrc = src;
      });
    // this.pushRightClass = 'push-right';
    this.subscriptions.push(
      this.requestService.currentUserSubject.subscribe((data) => {
        if (data) {
          this.selectedUser = data;
          // this.prefectureTitle = this.selectedUser.prefecture;
          this.pictureLink = data.pictureLink;
          // this.getUserPrefectureMetadata(this.selectedUser.prefecture);
          this.role = this.requestService.getUserRoleByText();
          this.isSuperAdmin = this.requestService.isUserRoleSuperAdmin();

          // this.buildSetting();
          this.loadData();

          // Fetch unread chat messages from backend to ensure persistence
          this.chatService.getUnreadMessages();
          // Fetch unread notifications
          this.notificationService.getUnreadNotifications();
        }
      })
    );

    this.subscriptions.push(
      this.notificationService.isThreatMuted.subscribe((isThreatMuted) => {
        if (isThreatMuted != undefined && this.isLoadedOnce) {
          this.muteThreatSound(isThreatMuted);
        } else {
          this.isLoadedOnce = true;
        }
      })
    );

    this.subscriptions.push(this.chatService.unreadSubject.subscribe((unread) => {
      // const filtered = unread.filter(item => item.id !== this.chatService.getSelectedChat());
      this.unread = unread;
      this.unreadNumber = this.unread.reduce((sum, item) => sum + item.count, 0);
      this.cdr.detectChanges();
    }));

    // this.subscriptions.push(
    //   this.requestService.pageOrganization.subscribe((data) => {
    //     if (data) {
    //       this.selectedOrganization = data._id;
    //     }
    //   })
    // );
    this.subscriptions.push(
      this.requestService.currentPageTitle.subscribe((data) => {
        if (data) {
          this.subTitle = data;
        }
      })
    );

    this.subscriptions.push(this.notificationService.dnd.subscribe((isDnd) => {
      this.isDnd = isDnd;
    }));

    this.subscriptions.push(this.notificationService.unread.subscribe((unread: any) => {
      this.unreadNotifications = unread;
      this.unreadNotificationsNumber = unread.reduce((sum, item) => sum + item.count, 0);
      if (this.notificationsMenuTrigger?.menuOpen) {
        this.getMenuNotifications();
      }
      this.cdr.detectChanges();
      // if (this.currentRoute !== '/notifications' || !unread?.length)
      //   this.showNotificationUnRead = unread?.length;
    }));

    // this.subscriptions.push(this.caseService.setNewCaseSubject.subscribe(profile => {
    //   if (profile) {
    //     this.newCase = profile;
    //     // const typeEnum = this.caseService.caseMetadata.fields?.find(i => i.name == 'casetype')?.enum;
    //     // this.newCase.casetype = this.enumPipe.transform(profile.casetype, typeEnum);
    //     clearTimeout(this.notificationTimeout);
    //     this.notificationTimeout = setTimeout(() => {
    //       this.newCase = undefined;
    //     }, 2 * 60 * 1000);
    //   }
    // }));

    this.subscriptions.push(this.notificationsHandlersService.currentMessage.subscribe(message => {
      const versionFromSignal = this.extractCodeVersionFromNatsMessage(message);
      if (versionFromSignal) {
        this.checkCodeVersionUpdate(versionFromSignal);
        return;
      }
      const callPayload = message?.data || message;
      const incomingType = callPayload?.type || message?.type;
      const incomingStatus = callPayload?.status || message?.status;
      const shouldShowInAppNotification = document.visibilityState === 'visible' && document.hasFocus();
      const isCallLikeType = ['call', 'call-invite', 'call-canceled'].includes(incomingType);
      const bypassDnd = shouldBypassDnd(incomingType, callPayload);
      const isCallControlThatBypassesDnd = bypassDnd && incomingType !== 'chat';
      const isIncomingCallInvite = callPayload?.type === 'call'
        && callPayload?.callSessionId
        && (callPayload?.callType === 'calls' || callPayload?.callType === 'invite' || !callPayload?.callType)
        && !callPayload?.status
        && !callPayload?.event
        && callPayload?.isCall !== false
        && !callPayload?.isCallAccepted
        && !callPayload?.isCallJoined;
      const isAnsweredSignal = isCallLikeType && (!!callPayload?.isCallAccepted || !!callPayload?.isCallJoined || callPayload?.type === 'call-invite');

      if (incomingType === 'call-canceled') {
        this.notificationsHandlersService.closeCallInviteNotifications(callPayload?.callSessionId);
        this.joinCallInvite = {};
        this.currentNotification = null;
        if (this.notificationTimer) {
          clearTimeout(this.notificationTimer);
          this.notificationTimer = undefined;
        }
      }

      // Call control events can arrive without message/title. Ensure they are still propagated.
      if (isAnsweredSignal || isCallControlThatBypassesDnd) {
        if (!this.isDnd || isCallControlThatBypassesDnd) {
          if (isAnsweredSignal) {
            callChannel.postMessage({ type: 'call-invite-accepted', payload: callPayload });
          } else {
            callChannel.postMessage({ type: 'call-status', payload: callPayload });
          }
        }
      }
      // Handle legacy notification structure
      let notificationBody = message?.notification?.body;
      let invitedBy = message?.data?.invitedBy;

      // Handle new NATS chat structure
      if (message?.type === 'chat' && message?.data) {
        const senderName = message.data.senderName || 'Unknown';
        const content = message.data.content || message.data.body || '';
        notificationBody = `${senderName}: ${content}`;
        invitedBy = message.data.invitedBy;
      } else if (message?.type === 'notify' && message?.data) {
        notificationBody = message.data.message || message.data.title;
      }

      if (message?.data?.senderId != this.selectedUser?._id) {
        if (message?.type === 'notify' || incomingType === 'notify') {
          this.refreshOpenNotificationsMenu();
        }

        if (notificationBody) {
          // this.notificationService.showNotificationUnRead.next(true);
          // this.notificationService.refreshData.next(true);
          // console.log(message)
          if ((!this.isDnd || bypassDnd) && shouldShowInAppNotification) {
            // if (this.notificationAudio) {
            //   this.notificationAudio.load();
            //   this.notificationAudio.loop = 0;
            //   this.notificationAudio.volume = 0.25;
            //   this.notificationAudio.play().catch((error: any) => { });
            // }
            // console.log('message from topnav', message)
            const isCallInvite = message?.data?.type === 'call'
              && message?.data?.callSessionId
              && (message?.data?.callType === 'calls' || message?.data?.callType === 'invite' || !message?.data?.callType)
              && !message?.data?.status
              && !message?.data?.event
              && message?.data?.isCall !== false
              && !message?.data?.isCallAccepted
              && !message?.data?.isCallJoined;

            if (!invitedBy || isCallInvite) {
              this.currentNotification = notificationBody;
              if (invitedBy) {
                this.joinCallInvite = message.data;
              }
              if (this.notificationTimer) {
                clearTimeout(this.notificationTimer);
                this.notificationTimer = undefined;
              }
              this.notificationTimer = setTimeout(() => this.currentNotification = null, 10000);
            }
          }
        }
        else
          this.currentNotification = null;
      }
    }));
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   this.screenWidth = window.innerWidth;
  // }


  // setSelectedOrganization(e, reload = true) {
  //   this.requestService.orgId = "5e5e69dd2023950162466258";
  //   this.storeService.set('orgId', '5e5e69dd2023950162466258');
  // }

  // isToggled(): boolean {
  //   const dom: Element = document.querySelector('body');
  //   return dom.classList.contains(this.pushRightClass);
  // }

  toggleSidebar() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle(this.pushRightClass);
  }

  onLoggedout() {
    // this.requestService.logout();
    this.notificationsHandlersService.logout();
  }

  // changeLang(language: string) {
  //   localStorage.setItem('languageSelected', language);
  //   this.languageSelected = language;
  //   this.translate.use(language);
  //   location.reload();
  // }

  // formatDate(seconds) {


  //   let output = new Date(seconds * 1000);

  //   return moment(output).format("YYYY-MM-DD HH:mm");


  // }

  // viewProfile() {
  //   const dialogRef = this.dialog.open(ModalUserViewDialogComponent, {
  //     width: '850px',
  //     data: {
  //       dataType: 'user',
  //       title: this.translate.instant('My Profile'),
  //       profile: true,
  //       data: this.selectedUser,
  //       modalSetting: undefined
  //     }
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       console.log('result', result);
  //     }
  //   });
  // }

  // changeLanguage() {
  //   const dialogRef = this.dialog.open(ModalLanguageDialogComponent, {
  //     width: '500px',
  //     data: {
  //       title: this.translate.instant('Language'),
  //     }
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       console.log('result', result);
  //     }
  //   });
  // }

  /**
   * @description - remove the red dot on the notifications if the menu is opened
   */
  // public handleMenuOpened() {
  //   if (this.hasNew) this.hasNew = !this.hasNew;
  // }
  // public goHome() {
  //   this.router.navigate(['/cases/list']);
  // }

  // closeNotification() {
  //   clearTimeout(this.notificationTimer);
  //   this.currentNotification = null;
  // }

  // joinMeeting(invited) {
  //   this.chatService.showCallDialogSubject.next({
  //     show: true,
  //     caseId: invited.caseId,
  //     invitedBy: invited.invitedBy,
  //     // investigators: invited.investigators,
  //   });
  // }
  // private getUserPrefectureMetadata(prefecture) {
  //   this.requestService.getMetaData('user', ['prefecture'], (data, error) => {
  //     if (error) {
  //     }
  //     // if (data && data.results && data.results.fields && data.results.fields.length > 0) {
  //     //   this.prefectureEnums = data.results.fields[0]?.enum || [];

  //       // console.log(this.prefectureEnums);
  //       // let prefectureObj = this.prefectureEnums.find((itm) => itm.value == prefecture);
  //       // console.log(prefectureObj);
  //       // if (prefectureObj?.length) {
  //         // this.prefectureTitle = prefectureObj[0].displayName;
  //       // }
  //     // }
  //   });
  // }

  editProfile() {
    this.menuTrigger.closeMenu();
    let title = this.translate.instant("Edit User Information");
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      autoFocus: false,
      width: "850px",
      data: {
        dataType: 'user',
        dataTypeTitle: 'User',
        title: title,
        data: { _id: this.selectedUser._id },
        modalSetting: this.getSetting({}),
        profile: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.action === 'refresh') {
        if (result.data) {
          this.requestService.updateCommonUserData(result.data);
        }
      }
      // setTimeout(function () {
      // 	window.location.reload();
      // }, 300);

    });
  }

  protected getSetting(data) {
    let tableSetting = data;
    tableSetting['target'] = 'self';

    tableSetting['customSettings'] = {
      organizationId: { visible: false },
      appId: { visible: false },
      locationId: { visible: false },
      resources: { visible: false },
      ref_id: { disabled: true }
    };
    if (!this.isSuperAdmin) {
      tableSetting['customSettings']['region'] = {
        visible: false
      }
    }
    if (!this.isSuperAdmin) {
      tableSetting['customSettings']['prefecture'] = {
        visible: false
      }
    }
    // if (this.requestService.checkListContains(this.data.data['resources'], environment.customKeys.roleClient)) {
    // 	tableSetting['customSettings']['ref_id']['visible'] = true;
    // } else {
    // 	tableSetting['customSettings']['ref_id']['visible'] = false;
    // }
    return tableSetting;
  }

  // private buildSetting() {
  //   if (!this.loading) {
  //     // this.DND = JSON.parse(localStorage.getItem("DND"));
  //     this.loading = true;
  //     this.loaderService.display(true);
  //     this.requestService.getMetaData('user', undefined, (data, error) => {
  //       if (error) {
  //         this.layoutUtilsService.showNotification(this.translate.instant('Error:') + error, this.translate.instant('Dismiss'));
  //       }
  //       this.loading = false;
  //       this.loaderService.display(false);
  //       if (data) {
  //         // this.data.modalSetting = data.results;
  //         // this.fieldsDetails = this.buildMetaSetting(data.results);
  //         // console.log('this.fieldsDetails', this.fieldsDetails);
  //         if (this.selectedUser.hasOwnProperty('_id')) {
  //           this.loadData();
  //         }
  //       } else {
  //         this.layoutUtilsService.showNotification(this.translate.instant('Something is Wrong'), this.translate.instant('Dismiss'));
  //       }
  //     });
  //   }
  // }

  public loadData() {
    if (!this.loading) {
      this.loading = true;
      this.loaderService.display(true);
      // let isGetValue = false;
      // let dataId = this.selectedUser._id;

      // if (this.data.dataType == 'user') {
      // isGetValue = true;
      // }
      this.requestService.getSingleData('user', this.selectedUser._id, (data, error) => {
        if (error) {
          this.layoutUtilsService.showNotification(this.translate.instant('Error:') + error, this.translate.instant('Dismiss'));
        }
        if (data) {
          // this.showChangePassword = data.results.is_original_email;
          // this.tableDataTemp = Object.assign({}, data.results);
          // this.data.confirmData = Object.assign({}, data.results);
          // console.log('this.data.confirmData ', this.data.confirmData);
          if (data.results['pictureLink']) {
            this.pictureLink = data.results['pictureLink'];
          }
          this.isDnd = data.results.dnd;
          this.isThreatMuted = data.results.muteThreats;
          this.notificationService.isThreatMuted.next(this.isThreatMuted);
        }
        this.loading = false;
        this.loaderService.display(false);
      });
    }
  }

  // buildMetaSetting(data, parent = undefined) {
  //   let dataObject = {};
  //   let tabObject = [];
  //   for (let col of data.fields) {
  //     if ((col.editable || !col.generated) && col.type !== 'object' && col.type !== 'table') {
  //       if (parent) {
  //         col['inputName'] = parent + col['name'];
  //       }
  //       dataObject[col.name] = col;
  //     } else if (col.type === 'object') {
  //       dataObject[col.name] = this.buildMetaSetting(col);
  //       tabObject.push({ name: col.name, displayName: col.displayName, fields: this.buildMetaSetting(col, col.name) });
  //     } else if (col.type === 'table') {
  //       dataObject[col.name] = this.buildMetaSetting(col);
  //     }
  //   }
  //   this.metaFieldTabsSetting = tabObject;
  //   return dataObject;
  // }

  goNotifications() {
    this.notificationsMenuTrigger?.closeMenu();
    this.router.navigate(['/notifications']);
  }

  goToNotificationGroup(message: any): void {
    this.notificationsMenuTrigger?.closeMenu();
    if (message?.caseId) {
      this.notificationService.markAsRead(this.selectedUser._id, { caseId: message.caseId });
      const caseId = message.caseId;
      this.router.navigateByUrl(`/case/${caseId}/notifications`).then(() => {
        if (this.currentRoute === `/case/${caseId}/notifications`) {
          window.location.reload();
        }
      });
      return;
    }

    this.notificationService.markAsRead(this.selectedUser._id, { ids: message?.ids || [] });
    this.router.navigateByUrl(`/notifications`).then(() => {
      if (this.currentRoute === '/notifications') {
        window.location.reload();
      }
    });
  }

  markAllNotificationsAsRead(): void {
    if (!this.selectedUser?._id) {
      return;
    }
    this.notificationService.markAsRead(this.selectedUser._id);
    this.notificationsList = this.notificationsList.map((notification) => ({ ...notification, isActive: false }));
    this.notificationsMenuTrigger?.closeMenu();
  }

  getMenuNotifications(): void {
    if (this.notificationsLoading) {
      this.notificationsRefreshPending = true;
      return;
    }

    this.notificationsRefreshPending = false;
    this.notificationsLoading = true;
    this.notificationsLoaded = false;

    this.notificationService.getNotifications('', 0, 10, undefined, ['requestcamera']).then((data: any) => {
      const notifications = data?.results || [];
      notifications.forEach((notification: any) => {
        notification.createdTimeAgo = moment(notification.updatedAt).fromNow();
        notification.isActive = this.isUnreadNotification(notification);
        notification.sentToInvestigators = this.caseService.getUserList(notification.investigators, notification.investigatorgroup);
      });
      this.notificationsList = notifications;
    }).catch((error) => {
      this.layoutUtilsService.showNotification(this.translate.instant('Error: ') + error, this.translate.instant('Dismiss'));
      this.notificationsList = [];
    }).finally(() => {
      this.notificationsLoaded = true;
      this.notificationsLoading = false;
      this.cdr.detectChanges();

      if (this.notificationsRefreshPending && this.notificationsMenuTrigger?.menuOpen) {
        this.getMenuNotifications();
      }
    });
  }

  viewNotification(notification: any): void {
    if (!notification) {
      return;
    }

    this.markNotificationAsRead(notification);
    this.notificationsMenuTrigger?.closeMenu();

    if (notification.note?._id && notification.type !== 'case') {
      this.loaderService.display(true);
      this.requestService.getRecord(notification.note._id, 'note', (data, error) => {
        if (data) {
          this.dialog.open(ViewTimelineDialogComponent, {
            autoFocus: false,
            width: '360px',
            data: {
              note: data.results,
              caseId: data.results.case?._id,
              metadata: this.caseService.noteMetadata.value,
              type: 'note',
              isReadOnly: data.results?.case?.deleted ? true : false,
              title: this.translate.instant('Note'),
              showTimelineBtn: true,
            }
          });
        }
        this.loaderService.display(false);
      });
      return;
    }

    if (notification.type === 'case' && notification.case?._id) {
      this.router.navigate([`/case/${notification.case._id}`]);
      return;
    }

    if (notification.type === 'missedcall') {
      if (notification.case?._id) {
        this.router.navigate([`/case/${notification.case._id}`]);
      } else if (!this.requestService.isUserRoleInvestigator() && notification.user?._id) {
        this.router.navigate([`/profile/${notification.user._id}`]);
      }
      return;
    }

    if (notification.case?._id) {
      this.router.navigate([`/case/${notification.case._id}/notifications`]);
      return;
    }

    this.router.navigate(['/notifications']);
  }

  private isUnreadNotification(notification: any): boolean {
    const notificationId = notification?._id?.toString?.() || notification?._id;
    if (!notificationId) {
      return false;
    }
    return (this.unreadNotifications || []).some((group: any) => (group.ids || []).includes(notificationId));
  }

  private markNotificationAsRead(notification: any): void {
    if (!this.selectedUser?._id || !notification?._id) {
      return;
    }
    this.notificationService.markAsRead(this.selectedUser._id, { notificationId: notification._id });
    this.notificationsList = this.notificationsList.map((item) => item._id === notification._id ? { ...item, isActive: false } : item);
  }

  changePassword() {
    this.menuTrigger.closeMenu();
    const dialogRef = this.dialog.open(ModalPasswordDialogComponent, {
      autoFocus: false,
      width: '550px',
      disableClose: true,
      data: {
        title: this.translate.instant('Change Password')
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('afterClosed', result);
      if (result) {
        //this.validateUser(userData);
      }
    });
  }
  callLogs() {
    this.menuTrigger.closeMenu();
    const dialogRef = this.dialog.open(LogsInvestigatorMapDialogComponent, {
      autoFocus: false,
      width: getResponsiveDialogWidth(),
      data: {
        userId: this.selectedUser._id,
        title: this.translate.instant('Call Log'),
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  saveDnd() {
    const userId = this.selectedUser?._id || this.requestService.getUserId();
    if (!userId) {
      return;
    }
    this.loaderService.display(true);
    this.isDnd = !this.isDnd;
    this.requestService.postRequest('user/' + userId, '', {
      dnd: this.isDnd
    }, async (data, error) => {
      if (data) {
        // DND suppresses only foreground in-app banners; keep device registered
        // so background notifications continue working when the tab is unfocused.
        this.layoutUtilsService.showNotification(this.translate.instant('updated successfully'), this.translate.instant('Dismiss'));
        this.loaderService.display(false);
      }
      else if (error) {
        this.layoutUtilsService.showNotification('Error: ' + error, this.translate.instant('Dismiss'));
        this.loaderService.display(false);
      }
      this.notificationService.dnd.next(this.isDnd);
    });
  }

  editProfileImage() {
    this.menuTrigger.closeMenu();
    const dialogRef = this.dialog.open(ModalCropDialogComponent, {
      width: '800px',
      disableClose: false,
      autoFocus: false,
      data: {
        title: 'Upload image',
        data: this.selectedUser,
        currentImage: this.pictureLink,
        profile: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result || result === '') {
        this.pictureLink = result;
        // if (result['status']) {
        // 	window.location.reload();
        // }
        //do nothing
      }
    });
  }

  changeLanguage() {
    const dialogRef = this.dialog.open(ModalLanguageDialogComponent, {
      autoFocus: false,
      width: '500px',
      data: {
        title: this.translate.instant('Language'),
        userId: this.selectedUser._id,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log('result', result);
      }
    });
  }

  openUnReadDialog() {
    if (!this.unreadNumber)
      return;

    this.menuTrigger?.closeMenu();
    const dialog = this.dialog.open(UnReadChatDialogComponent, {
      autoFocus: false,
      disableClose: false,
      // width: 'fit-content',
      width: '30vw',
      data: {
        // unread: Object.entries(this.unread).map(([key, value]) => ({ senderId: key, messages: value }))
        unread: this.unread,
        currentUserId: this.selectedUser._id,
      }
    });
  }

  openUnReadNotificationsDialog() {
    this.menuTrigger.closeMenu();
    const dialog = this.dialog.open(UnReadNotificationsDialogComponent, {
      autoFocus: false,
      disableClose: false,
      // width: 'fit-content',
      width: '30vw',
      data: {
        unread: this.unreadNotifications,
        currentUserId: this.selectedUser._id,
      }
    });
  }

  askSupport() {
    this.menuTrigger.closeMenu();
    const dialog = this.dialog.open(SupportDialogComponent, {
      disableClose: false,
      width: getResponsiveDialogWidth(),
    })
  }

  toggleMuteSound() {
    this.muteThreatSound();
  }

  muteThreatSound(mute?: boolean) {
    const nextState = mute !== undefined ? mute : !this.isThreatMuted;

    if (this.isThreatMuted === nextState) {
      return;
    }

    const userId = this.selectedUser?._id || this.requestService.getUserId();
    if (!userId) {
      return;
    }

    this.loaderService.display(true);
    this.isThreatMuted = nextState;
    this.requestService.postRequest('user/' + userId, '', {
      muteThreats: this.isThreatMuted
    }, async (data, error) => {
      if (data) {
        this.layoutUtilsService.showNotification(this.translate.instant('updated successfully'), this.translate.instant('Dismiss'));
        this.notificationService.isThreatMuted.next(this.isThreatMuted);
      }
      else if (error) {
        this.layoutUtilsService.showNotification('Error: ' + error, this.translate.instant('Dismiss'));
      }
      this.loaderService.display(false);
    });
  }

  @HostListener('document:fullscreenchange')
  onFullscreenChange(): void {
    this.isFullscreen = !!document.fullscreenElement;
  }

  async toggleFullscreen(): Promise<void> {
    if (document.fullscreenElement) {
      await document.exitFullscreen();
    } else {
      await document.documentElement.requestFullscreen();
    }
    this.isFullscreen = !!document.fullscreenElement;
  }

  toggleResetView(): void {
    this.caseService.dashboardResetView.next();
    this.caseService.timelineCollapsed.next(false);
  }

  private checkCodeVersionUpdate(configuredVersion: string): void {
    const incomingVersion = (configuredVersion || '').trim();
    if (!incomingVersion) {
      return;
    }

    const storedVersion = (localStorage.getItem(this.CODE_VERSION_STORAGE_KEY) || '').trim();
    const alreadyPromptedForThisVersion =
      this.hasPromptedCodeVersionUpdate && this.lastPromptedCodeVersion === incomingVersion;
    if (storedVersion === incomingVersion || alreadyPromptedForThisVersion) {
      return;
    }

    if (!storedVersion) {
      localStorage.setItem(this.CODE_VERSION_STORAGE_KEY, incomingVersion);
      return;
    }

    this.hasPromptedCodeVersionUpdate = true;
    this.lastPromptedCodeVersion = incomingVersion;

    const dialogRef = this.layoutUtilsService.alertActionElement(
      this.translate.instant('Update ready to install'),
      '',
      {
        confirmText: this.translate.instant('Update now'),
        overlayClickToClose: false,
      },
      'fit-content'
    );

    dialogRef.afterClosed().subscribe((result) => {
      localStorage.setItem(this.CODE_VERSION_STORAGE_KEY, incomingVersion);
      if (result?.action === 'confirmText') {
        window.location.reload();
      }
    });
  }

  private extractCodeVersionFromNatsMessage(message: any): string | null {
    const data = message?.data || message || {};
    const type = String(message?.type || data?.type || '').toLowerCase();
    const action = String(data?.action || '').toLowerCase();
    const signal = String(data?.signal || '').toLowerCase();
    const isVersionSignal =
      type === 'code-version-update' ||
      type === 'code_version_update' ||
      action === 'code-version-update' ||
      action === 'code_version_update' ||
      signal === 'code-version-update' ||
      signal === 'code_version_update';
    if (!isVersionSignal) {
      return null;
    }
    const version = String(data?.codeVersion || data?.version || '').trim();
    return version || null;
  }

  private refreshCaseDashboardRoute(url: string): void {
    const path = url.split('?')[0].split('#')[0];
    this.isCaseDashboardPage = /^\/case\/[^/]+\/?$/.test(path);
  }

  openHomePage() {
    this.router.navigate(['/cases/list']);
  }

  showNotifications() {
    this.notificationService.getUnreadNotifications();
    this.getMenuNotifications();
    this.notificationsMenuTrigger?.openMenu();
  }

  private refreshOpenNotificationsMenu(): void {
    if (!this.notificationsMenuTrigger?.menuOpen) {
      return;
    }

    this.notificationService.getUnreadNotifications();
    this.getMenuNotifications();
  }
}
